import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectTreeNode } from '@models/project-tree-node.interface';

@Component({
  selector: 'app-tree-node',
  standalone: true,
  imports: [CommonModule, TreeNodeComponent],
  templateUrl: './tree-node.component.html',
  styleUrl: './tree-node.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TreeNodeComponent {
  // ── Inputs / Outputs ───────────────────────────────────────────────────
  node = input.required<ProjectTreeNode>();
  /** Key of the currently selected node, threaded down for OnPush-safe highlighting. */
  selectedKey = input<string | null>(null);
  nodeSelected = output<ProjectTreeNode>();

  protected readonly isSelected = computed(() => this.node().key === this.selectedKey());

  // ── Expand/collapse ────────────────────────────────────────────────────
  protected selectNode(): void {
    this.nodeSelected.emit(this.node());
  }

  protected toggleExpand(event: MouseEvent): void {
    event.stopPropagation();
    const n = this.node();
    if (n.children?.length) {
      n.isExpanded = !n.isExpanded;
    }
  }

  protected onChildSelected(node: ProjectTreeNode): void {
    this.nodeSelected.emit(node);
  }

  protected hasChildren(): boolean {
    return (this.node().children?.length ?? 0) > 0;
  }
}
